module.exports = __webpack_public_path__ + "img/tu08.af513f6f.png";